import { useAuth } from 'context/AuthContext';
import { hasUserAccess, isSellerUser } from 'utils/helpers/access/hasUserAccess';
import { ObjectWarranties } from 'modules/warranties';
import { useObjectCard } from '../context/ObjectCardProvider';

const ObjectTabWarranties = () => {
    const { auth } = useAuth();
    const { objectId, vObject, isEditLocked } = useObjectCard();
    const canEdit =
        hasUserAccess(auth?.user, 'prodEdit') &&
        !isEditLocked &&
        (!isSellerUser(auth?.user) || vObject?.object?.myAccess === 'edit');
    return <ObjectWarranties objectId={Number(objectId)} canEdit={canEdit} />;
};

export default ObjectTabWarranties;
